// components/RecentlyVisited.tsx
import { LinkNoPrefetch } from '@/components/Link'
import { useVisitedPages } from '@/hooks/useRecentlyVisited'
import { useEffect, useState } from 'react'

const RecentlyVisited = () => {
	const visitedPages = useVisitedPages()
	const [isClient, setIsClient] = useState(false)

	// SSR-safe: only render after hydration (avoids localStorage mismatch)
	useEffect(() => {
		setIsClient(true)
	}, [])

	if (!isClient) return null
	if (visitedPages.length === 0) return null

	return (
		<section
			className="nsw-section"
			css={{
				paddingTop: '2rem',
				paddingBottom: '2rem',
				backgroundColor: 'var(--nsw-off-white)',
			}}
		>
			<div className="nsw-container">
				<h3 css={{ margin: '0 0 1rem 0' }}>Your Visited Pages</h3>
				<ul
					css={{
						listStyle: 'none',
						margin: 0,
						padding: 0,
						display: 'flex',
						flexWrap: 'wrap',
						gap: '0.5rem 1.5rem',
					}}
				>
					{visitedPages.map((page) => (
						<li key={page.url}>
							<LinkNoPrefetch
								href={page.url}
								css={{
									color: 'var(--nsw-brand-dark)',
									textDecoration: 'underline',
									'&:visited, &:hover': {
										// Force brand-dark - no purple on :visited
										color: 'var(--nsw-brand-dark)',
									},
								}}
							>
								{page.title}
							</LinkNoPrefetch>
						</li>
					))}
				</ul>
			</div>
		</section>
	)
}

export default RecentlyVisited
